import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { Notification } from "../../../components/GenericActions";
import homeScreenService from "./homeTesting.service";

const initialState = {
  homeTestingList: null,
  allHomeTestingList: [],
  homeTestingOfSinglePatient: [],
  patientHomeTestingSubscriptionSave: null,

  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const createHomeTesting = createAsyncThunk(
  "/homeTesting/save",
  async ({ finalData, onCreateSuccess }, thunkAPI) => {
    try {
      const response = await homeScreenService.createHomeTesting(finalData);
      if (response.succeeded === true) {
        if (onCreateSuccess) {
          onCreateSuccess(response);
        }
      }
      Notification(response.message, response.succeeded);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllHomeTesting = createAsyncThunk(
  "homeTestingList/getAll",
  async (thunkAPI) => {
    try {
      return await homeScreenService.getAllHomeTesting();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      Notification("Network Error", false);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const allHomeTestingOfPatient = createAsyncThunk(
  "homeTesting/getHomeTestingByPatientId",
  async (finalData, thunkAPI) => {
    try {
      return await homeScreenService.getHomeTestingByPatientId(finalData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const patientHomeTestingSubscriptionSaveData = createAsyncThunk(
  "subscriptionSave/patient",
  async ({ finalData, moveToNext }, thunkAPI) => {
    try {
      const response = await homeScreenService.patientHomeTestingSubscriptionSave(
        finalData
      );
      if (response.succeeded === true) {
        if (moveToNext) {
          moveToNext(response);
        }
      }
      Notification(response.message, response.succeeded);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const homeTestingSlice = createSlice({
  name: "homeTesting",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(createHomeTesting.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(createHomeTesting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.homeTestingList = action.payload.data;
      })
      .addCase(createHomeTesting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })
      .addCase(getAllHomeTesting.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(getAllHomeTesting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.allHomeTestingList = action.payload.data;
      })
      .addCase(getAllHomeTesting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })
      .addCase(allHomeTestingOfPatient.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(allHomeTestingOfPatient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.homeTestingOfSinglePatient = action.payload.data;
      })
      .addCase(allHomeTestingOfPatient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })
      .addCase(patientHomeTestingSubscriptionSaveData.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(
        patientHomeTestingSubscriptionSaveData.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.patientHomeTestingSubscriptionSave = action.payload.data;
        }
      )
      .addCase(
        patientHomeTestingSubscriptionSaveData.rejected,
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.statusMessage = action.payload;
        }
      );
  },
});
export const { clearData } = homeTestingSlice.actions;

export default homeTestingSlice.reducer;
